import { useState } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

import ebiOfficeService from "api/ebiOfficeService";
import HollowButton from "components/HollowButton";

import EbiAppearanceTab from "./EbiAppearanceTab";
import EbiBasicTab from "./EbiBasicTab";
import EbiFormsTab from "./EbiFormsTab";
import EbiNotificationsTab from "./EbiNotificationsTab";
import styles from "./styles.module.scss";
import { EbiSubTab, FC } from "./typings";

// Elektroniczne Biuro Interesanta (EBI) — ustawienia urzędu w podzakładkach: Podstawowe (kanał, adres portalu,
// nazwa urzędu, kolejka udostępnień, usługi przeszyfrowań), Wnioski (rodzaje wniosków przyjmowanych w portalu), Wygląd
// (kolory portalu) i Powiadomienia (szablony maili z podglądem na danych z zakładki Urząd). Podzakładki jak w sąsiednich
// zakładkach ustawień (Wygląd, Zespół, Integracje). Dopóki urząd nie jest połączony z platformą EBI (Podstawowe),
// pozostałe podzakładki pokazują tylko komunikat.

const SUB_TABS: EbiSubTab[] = ["basic", "forms", "appearance", "notifications"];

const EbiTab: FC = () => {
  const { t } = useTranslation();
  const [subTab, setSubTab] = useState<EbiSubTab>("basic");
  const { data: settingsData } = ebiOfficeService.useGetSettings();
  // BE sprzed wydzielenia platformy EBI nie zwraca IsConnected — wtedy bez blokady
  const isLocked = settingsData?.data?.IsConnected === false && subTab !== "basic";

  return (
    <div className={styles.wrapper}>
      <div className={styles.subTabs}>
        {SUB_TABS.map((key) => (
          <div
            key={key}
            className={classNames(styles.subTab, subTab === key && styles.subTabActive)}
            onClick={() => setSubTab(key)}
          >
            {t(`ebiOffice.tabs.${key}`)}
          </div>
        ))}
      </div>

      <div className={styles.body}>
        {isLocked ? (
          <div className={styles.column}>
            <div className={styles.section}>
              <div className={styles.hint}>{t("ebiOffice.connection.locked")}</div>
              <div className={styles.actions}>
                <HollowButton text={t("ebiOffice.connection.goToBasic")} onClick={() => setSubTab("basic")} />
              </div>
            </div>
          </div>
        ) : (
          <>
            {subTab === "basic" && <EbiBasicTab />}
            {subTab === "forms" && <EbiFormsTab />}
            {subTab === "appearance" && <EbiAppearanceTab />}
            {subTab === "notifications" && <EbiNotificationsTab />}
          </>
        )}
      </div>
    </div>
  );
};

export default EbiTab;
